<template>
 <div class="overlay-dropdown"
      :class="{show: isOpen}"
      @click="toggleDropDown"
      v-click-outside="closeDropDown">

    <div class="dropdown-toggle"
      data-toggle="dropdown">
      <slot name="title">
        <div class="overlay-dropdown-title">
          {{title}}<img class="dropdown" src="@/assets/static/img/dropdown.png" alt="..."/>
        </div>
      </slot>
    </div>
    <div class="overlay-dropdown-menu" v-show="isOpen">
      <div class="overlay-dropdown-item" v-for="option in options" :key="option" @click="onOptionSelected(option)">
        {{option}}
      </div>
    </div>
 </div>
</template>

<script>
  export default {
    name: 'overlay-dropdown',
    props: {
      title: String,
      options: Array,
    },
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      onOptionSelected(option) {
        this.$emit('onOptionSelected', option)
      },
      toggleDropDown () {
        this.isOpen = !this.isOpen
      },
      closeDropDown () {
        this.isOpen = false
      }
    }
  }
</script>